import React from 'react'
import P2PHistoryTable from '../../../components/transactionNew/P2P/P2pHistoryTable'
import { useWindowSize } from '../../../modules/staking'
import { MOBILE_SIZE } from '../../../core/constants/common'
import RP2PHistoryTable from '../../../components/transactionNew/P2P/RP2pHistoryTable'

const P2PHistory = () => {
    const { width } = useWindowSize()
    return (
        <>{width > MOBILE_SIZE ? <P2PHistoryTable /> : <RP2PHistoryTable />}</>
    )
}

export default P2PHistory